import { buildHref } from "@softmax/web-addresses";
import { frontDoorPath } from "../../coworlds/creator-rooms";
import type { SiteSearchCoworldContext } from "./search-input";

export function searchHrefOf({
  coworld,
  search,
}: {
  readonly coworld?: SiteSearchCoworldContext | undefined;
  readonly search?: URLSearchParams | undefined;
}): string {
  if (!coworld) return buildHref({ name: "search", search });

  return buildHref({
    name: "game.search",
    game: coworld.route.game,
    search,
  });
}

export function returnHrefOf({
  from,
  coworld,
}: {
  readonly from: string | null;
  readonly coworld: SiteSearchCoworldContext | undefined;
}) {
  const fallback = coworld
    ? frontDoorPath({ corpusSlug: coworld.corpusSlug, route: coworld.route })
    : buildHref({ name: "browse" });

  if (
    !from?.startsWith("/") ||
    from.startsWith("//") ||
    from.includes("\\") ||
    Array.from(from).some((character) => {
      const code = character.charCodeAt(0);
      return code < 32 || code === 127;
    }) ||
    /%(?![0-9a-f]{2})/i.test(from)
  )
    return fallback;

  const target = new URL(from, window.location.origin);

  if (
    target.origin !== window.location.origin ||
    target.pathname.startsWith("//")
  )
    return fallback;

  return `${target.pathname}${target.search}${target.hash}`;
}
export function querySearchHref({
  coworld,
  search,
  query,
}: {
  readonly coworld: SiteSearchCoworldContext | undefined;
  readonly search: URLSearchParams;
  readonly query: string;
}): string {
  const params = new URLSearchParams(search);

  if (query.trim()) params.set("q", query);
  else params.delete("q");

  return searchHrefOf({ coworld, search: params });
}
